<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <p class="text-secondary mb-3">
        Add details for every item in the list. After saving you can see team details.
      </p>

      @if (projectId) {
        <div class="alert alert-warning">
          <div class="row">
            <div class="col-12">
              <p class="mb-2">
                <strong>Note:</strong> In order to guarantee impartiality and independence in relation to the tasks to be carried out, we ask the client to carefully review the team created below. Please inform us if any of the people mentioned below has or had any connection with your company.
              </p>
            </div>
          </div>
          <div class="row mt-3" [formGroup]="teamConflictForm">
            <div class="col-12">
              <div class="row">
                <div class="col-auto">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="noConflict"
                      name="conflictType"
                      [value]="false"
                      formControlName="hasConflict"
                      (change)="onConflictTypeChange(false)"
                      [disabled]="!teamConflictEditable || !isCustomerProfile">
                    <label class="form-check-label text-success" for="noConflict">
                      <strong>No conflict with all people of the company</strong>
                    </label>
                  </div>
                </div>
                <div class="col-auto">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="hasConflict"
                      name="conflictType"
                      [value]="true"
                      formControlName="hasConflict"
                      (change)="onConflictTypeChange(true)"
                      [disabled]="!teamConflictEditable || !isCustomerProfile">
                    <label class="form-check-label text-danger" for="hasConflict">
                      <strong>Conflict: Comment about if (write the name of the persons)</strong>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          @if (teamConflictForm.get('hasConflict')?.value) {
            <div class="row mt-2" [formGroup]="teamConflictForm">
              <div class="col-12">
                <textarea
                  class="form-control"
                  formControlName="notes"
                  placeholder="Write the names of the persons and any additional details..."
                  rows="3"
                  [disabled]="!teamConflictEditable || !isCustomerProfile">
                </textarea>
              </div>
            </div>
          }
          @if (teamConflictCreatorName && teamConflictCreateTime) {
            <div class="row mt-2">
              <div class="col-12">
                <div class="mt-2 text-muted small">
                  <p class="mb-0">
                    <strong>Confirmed at {{ teamConflictCreateTime | date:'yyyy-MM-dd HH:mm:ss' }} by {{ teamConflictCreatorName }}</strong>
                  </p>
                </div>
              </div>
            </div>
          }
          @if (teamConflictEditable && isCustomerProfile) {
            <div class="row mt-3">
              <div class="col-12">
                <button
                  class="btn btn-primary"
                  (click)="saveTeamConflicts()"
                  [disabled]="teamConflictLoading || teamConflictForm.get('hasConflict')?.value === null">
                  <i class="fa fa-save me-2"></i>
                  Save
                </button>
              </div>
            </div>
          }
        </div>
      }

      <div class="row mt-3">
        <div class="col-md-8" [hidden]="!canViewAvailableStaff">
          <div class="card mb-4">
            <div class="card-header bg-light">
              <h3 class="card-title">AVAILABLE STAFF</h3>
            </div>
            <div class="card-body" (dragover)="onDragOver($event)" (drop)="onDropBackToAvailableStaff($event)">
              <div class="table-responsive available-staff-scroll">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>N Pj</th>
                      <th>Role</th>
                      <th>Specialization</th>
                      <th>Work %</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (staff of filteredAvailableStaff; track staff) {
                      <tr
                        draggable="true"
                        (dragstart)="onDragStart($event, staff)"
                        >
                        <td>
                          <div class="d-flex align-items-center">
                            <span class="text-success me-2">●</span>
                            {{ staff.employee.firstName }} {{ staff.employee.lastName }}
                          </div>
                        </td>
                        <td>{{ staff.workingProjects.length }}</td>
                        <td>{{ staff.employee.role }}</td>
                        <td>{{ staff.employee.employeeSpecialisations.length }}</td>
                        <td>
                          <div class="progress" style="height: 10px;">
                            <div class="progress-bar bg-success" role="progressbar" [style.width]="(staff.workPercent || 60) + '%'"
                            [attr.aria-valuenow]="staff.workPercent || 60" aria-valuemin="0" aria-valuemax="100"></div>
                          </div>
                          <small>{{ staff.workPercent || 60 }}%</small>
                        </td>
                        <td>
                          <div class="btn-group">
                            <button class="btn btn-sm btn-info" (click)="openPersonDetailModal(personDetailModal, staff)">
                              <i class="fa fa-solid fa-eye"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div [class]="canViewAvailableStaff ? 'col-md-4' : 'col-md-12'">
          <div class="card mb-4">
            @if (canEditAssignment) {
            <div class="card-header bg-light">
              <h3 class="card-title">CREATE TEAM</h3>
            </div>
            }
            <div class="card-body p-0">
              <form [formGroup]="form">
                <div class="create-team-scroll p-3">
                <div formGroupName="teamLeader">
                  <div class="row mb-4">
                    <div class="col-12 mb-2">
                      <label class="fw-bold">Team Leader</label>
                    </div>
                    <div class="col-12"
                      (dragover)="onDragOver($event)"
                      (drop)="onDrop($event, true)"
                      draggable="true" (dragstart)="onDragTeamLeaderStart($event, teamLeaderForm.value)">
                      <div class="card shadow-sm p-2 mb-3">
                        <div class="row mb-2">
                          <div class="col-7">
                            <input-field
                              [inputFormControl]="$any(teamLeaderForm.get('name'))"
                              label="Name"
                              [readonly]="!canEditAssignment"
                              placeholder="Enter team leader name">
                          </input-field>
                        </div>
                        @if (canEditAssignment) {
                        <div class="col-3">
                          <input-field
                            [inputFormControl]="$any(teamLeaderForm.get('hours'))"
                            label="Hours"
                            type="number"
                            [readonly]="!canEditAssignment"
                            placeholder="Hours">
                        </input-field>
                        </div>
                        }
                      @if (canUseMoodButton) {
                      <div class="col-2 d-flex align-items-center justify-content-center">
                        <div class="position-relative">
                            <button class="btn btn-lg btn-mood" [ngClass]="{
                              'btn-success': teamLeaderForm.get('mood')?.value === 'happy',
                              'btn-warning': teamLeaderForm.get('mood')?.value === 'neutral',
                              'btn-danger': teamLeaderForm.get('mood')?.value === 'sad',
                            }" type="button" (click)="openTeamLeaderMoodSelector()">
                              <i class="fa" [ngClass]="{
                                'fa-smile-o': teamLeaderForm.get('mood')?.value === 'happy',
                                'fa-meh-o': teamLeaderForm.get('mood')?.value === 'neutral',
                                'fa-frown-o': teamLeaderForm.get('mood')?.value === 'sad',
                              }"></i>
                          </button>
                          @if (selectedPersonIndex === -1) {
                            <div class="mood-selector bg-white p-2 shadow-sm">
                              <div class="d-flex">
                                <button class="btn btn-sm btn-danger me-1" (click)="selectTeamLeaderMood('sad', $event)">
                                  <i class="fa fa-frown-o"></i>
                                </button>
                                <button class="btn btn-sm btn-warning me-1" (click)="selectTeamLeaderMood('neutral', $event)">
                                  <i class="fa fa-meh-o"></i>
                                </button>
                                <button class="btn btn-sm btn-success me-1" (click)="selectTeamLeaderMood('happy', $event)">
                                  <i class="fa fa-smile-o"></i>
                                </button>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-12 mb-2">
                <label class="fw-bold">Other Team Members</label>
              </div>
            </div>

            <div formArrayName="teamMembers" (dragover)="onDragOver($event)" (drop)="onDrop($event)">
              @if (canEditAssignment) {
              <div class="mb-4">
                <div class="card shadow-sm p-2 mb-3 border-dashed">
                  <div class="row mb-2">
                    <div class="col-12 text-center text-muted">
                      <i class="fa fa-plus-circle me-2"></i>
                      <span>Drag and drop team members here</span>
                    </div>
                  </div>
                </div>
              </div>
              }

              @for (member of teamMembers.controls; track member; let i = $index) {
                <div [formGroupName]="i"
                  class="mb-4" draggable="true" (dragstart)="onDragMemberStart($event, member.value, i)">
                  <div class="card shadow-sm p-2 mb-3">
                    <div class="row mb-2">
                      <div class="col-7">
                        <input-field
                          [inputFormControl]="$any(member.get('name'))"
                          label="Name"
                          [readonly]="!canEditAssignment"
                          placeholder="Enter team member name">
                      </input-field>
                    </div>
                    @if (canEditAssignment) {
                    <div class="col-3">
                      <input-field
                        [inputFormControl]="$any(member.get('hours'))"
                        label="Hours"
                        type="number"
                        [readonly]="!canEditAssignment"
                        placeholder="Hours">
                    </input-field>
                    </div>
                    }
                  @if (canUseMoodButton) {
                  <div class="col-2 d-flex align-items-center justify-content-center">
                    <div class="position-relative">
                            <button class="btn btn-lg btn-mood" [ngClass]="{
                              'btn-success': member.get('mood')?.value === 'happy',
                              'btn-warning': member.get('mood')?.value === 'neutral',
                              'btn-danger': member.get('mood')?.value === 'sad'
                            }" type="button" (click)="openMoodSelector(i)">
                              <i class="fa" [ngClass]="{
                                'fa-smile-o': member.get('mood')?.value === 'happy',
                                'fa-meh-o': member.get('mood')?.value === 'neutral',
                                'fa-frown-o': member.get('mood')?.value === 'sad'
                              }"></i>
                      </button>
                      @if (selectedPersonIndex === i) {
                        <div class="mood-selector bg-white p-2 shadow-sm" >
                          <div class="d-flex">
                            <button class="btn btn-sm btn-danger me-1" (click)="selectMood('sad', $event)">
                              <i class="fa fa-frown-o"></i>
                            </button>
                            <button class="btn btn-sm btn-warning me-1" (click)="selectMood('neutral', $event)">
                              <i class="fa fa-meh-o"></i>
                            </button>
                            <button class="btn btn-sm btn-success me-1" (click)="selectMood('happy', $event)">
                              <i class="fa fa-smile-o"></i>
                            </button>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>

                </div>
                @if (canEditAssignment) {
                <div class="create-team-totals border-top px-3 py-2">
                  <div class="row mt-2">
                    <div class="col-6">
                      <label class="fw-bold">Tot. Real Hours:</label>
                      <input type="text" class="form-control" formControlName="totalRealHours" readonly>
                    </div>
                    <div class="col-6">
                      <label class="fw-bold">Tot. Est. Hours:</label>
                      <input type="text" class="form-control" formControlName="totalEstimatedHours" readonly>
                    </div>
                  </div>
                </div>
                }
      </form>
    </div>
  </div>
  @if (canSendApproval && teamChanged) {
    <div class="mt-3">
      <button type="button" class="btn btn-primary w-100" (click)="sendApprovalToClient()" [disabled]="sendingApproval">
        <i class="fa fa-paper-plane me-2"></i>
        Send approval to client
      </button>
    </div>
  }
</div>
</div>
</div>
</div>
</div>

<ng-template #personDetailModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Staff Details</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <div class="container-fluid">
      @if (loadingPersonDetails) {
        <loader [config]="{ overlay: false, text: 'Loading...' }"></loader>
      }

      @if (!loadingPersonDetails && selectedPersonDetails) {
        <div class="row">
          <div class="col-12">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>PROJECT</th>
                  <th>COMPANY</th>
                  <th>STATUS</th>
                  <th>DUE DATE</th>
                </tr>
              </thead>
              <tbody>
                @for (project of selectedPersonDetails.projects; track project) {
                  <tr>
                    <td>{{ project.code }}</td>
                    <td>{{ project.company }}</td>
                    <td><span class="badge" [ngClass]="'bg-' + project.statusClass">{{ project.status }}</span></td>
                    <td>{{ project.dueDate | date:'dd MMM' }}</td>
                  </tr>
                }
                @if (!selectedPersonDetails.projects?.length) {
                  <tr>
                    <td colspan="4" class="text-center">No active projects</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.close()">Close</button>
  </div>
</ng-template>


